//import Components
import PropTypes, {object} from "prop-types";
import TopNav from "../components/navigation/top/TopNav";
import SideNav from "../components/navigation/left/SideNav";
import {Col} from "reactstrap";
import PageContainer from "./PageContainer";
import {useAppState} from "../context/state";
import {useState} from "react";

PageLayout.propTypes = {
    children: PropTypes.object,
    pageLinks: PropTypes.arrayOf(object)
}

PageLayout.defaultProps = {
    children: null
}


export default function PageLayout ({pageLinks, ...props}) {
    const [appState] = useAppState();
    const [sideNavOpen, setSideNavOpen] = useState(true);

    return (
        <div className={sideNavOpen ?
            "page"
            :
            "page--min"
        }>
            <TopNav
                sideNavState={[sideNavOpen, setSideNavOpen]}
                className={"topNav"}/>
            <PageContainer>
                <Col
                    className={"sideNav"}
                    md="auto"
                >
                    <SideNav/>
                </Col>

                <Col
                    className={ appState.sideMenuOpen ?
                        "page_container--min"
                        :
                        "page_container"
                    }
                    md="fill"
                >
                    {props.children}
                </Col>
            </PageContainer>
        </div>
    )
}
